module.exports = __webpack_public_path__ + "assets/images/grad-porec.png";